//Materialize
import '../stylus/contactenos.styl'

//FontAwsome
import '../libs/fontawsome/css/fontawesome-all.min.css'
import '../libs/fonda-paisa/style.css'
// modernizr
import '../libs/modernizr/modernizr-custom.js'

import {espCalendar, createCarrousel, cambioSede} from './include/global.js'

let carousel
$(document).ready(function(){
	
	cambioSede(locales, $('.info [name="idResp"]').val(), $('.carousel.carousel-slider:not(#big-banner)'), $('.info [name="idTEvento"]'), undefined, undefined, $('.descripcion'))
	$('.info [name="idResp"]').on('change', function(){
		cambioSede(locales, $(this).val(), $('.carousel.carousel-slider:not(#big-banner)'), $('.info [name="idTEvento"]'), undefined, undefined, $('.descripcion'))
	})
})


// WEBPACK FOOTER //
// ./src/js/contactenos.js